import { useCallback, useMemo } from 'react';
import { useAuth, ManagedLocation } from './useAuth';

/**
 * Small helpers so screens hide the buttons someone may not use. This is
 * cosmetic only; the backend enforces the same rules on every request.
 */
export const usePermissions = () => {
  const { user, isSuperAdmin, needsLocationChoice, role, locations } = useAuth();

  const managedLocationIds = useMemo(
    () => (locations || []).map((location: ManagedLocation) => location.id),
    [locations]
  );

  const canManageLocation = useCallback(
    (locationId?: number | null) => {
      if (isSuperAdmin) return true;
      if (locationId === undefined || locationId === null) return false;
      return managedLocationIds.includes(Number(locationId));
    },
    [isSuperAdmin, managedLocationIds]
  );

  return {
    role,
    isSuperAdmin,
    isBeheerder: role === 'beheerder' || isSuperAdmin,
    hasAccess: Boolean(user?.isAdmin),
    needsLocationChoice,
    managedLocations: locations || [],
    managedLocationIds,
    canManageLocation,
    canManageLocations: isSuperAdmin,
    canManageBikeTypes: isSuperAdmin,
    canManageUsers: isSuperAdmin,
  };
};
